import { useEffect } from 'react';
import useSnapshotStreamingStore from '../Stores/SnapshotStreamingStore';

const STREAMING_WS_URL =
  process.env.REACT_APP_STREAMING_WEBSOCKET_URL ||
  'wss://streaming-data-wss-e49054216df5.herokuapp.com/ws?feed=snapshot';

export default function StreamingWebsocketClient() {
  const setSpxSnapshot = useSnapshotStreamingStore(
    state => state.setSpxSnapshot
  );

  useEffect(() => {
    let ws = null;
    let reconnectTimeout = null;
    let pingInterval = null;
    let manuallyClosed = false;

    const connectWebSocket = () => {
      ws = new WebSocket(STREAMING_WS_URL);

      ws.onopen = () => {
        pingInterval = setInterval(() => {
          if (ws && ws.readyState === WebSocket.OPEN) {
            ws.send(JSON.stringify({ type: 'ping' }));
          }
        }, 30000);
      };

      ws.onmessage = event => {
        try {
          const response = JSON.parse(event.data);

          // This app only cares about SPX market snapshots.
          if (
            response.type !== 'market_snapshot' ||
            response.symbol !== 'I:SPX'
          ) {
            return;
          }

          setSpxSnapshot({
            current: response.current,
            previousClose: response.previousClose,
            change: response.change,
            changePercent: response.changePercent,
          });
        } catch (error) {
          console.error('[STREAMING WSS] Error processing message:', error);
          console.error('[STREAMING WSS] Raw message:', event.data);
        }
      };

      ws.onclose = event => {
        if (pingInterval) {
          clearInterval(pingInterval);
          pingInterval = null;
        }

        console.log(
          `[STREAMING WSS] Connection closed code=${event.code}, reason=${event.reason}`
        );

        if (!manuallyClosed) {
          scheduleReconnect();
        }
      };

      ws.onerror = error => {
        console.error('[STREAMING WSS] WebSocket error:', error);
      };
    };

    const scheduleReconnect = () => {
      if (reconnectTimeout) return;

      reconnectTimeout = setTimeout(() => {
        reconnectTimeout = null;
        connectWebSocket();
      }, 3000);
    };

    const cleanupWebSocket = () => {
      manuallyClosed = true;

      if (reconnectTimeout) {
        clearTimeout(reconnectTimeout);
        reconnectTimeout = null;
      }

      if (pingInterval) {
        clearInterval(pingInterval);
        pingInterval = null;
      }

      if (ws) {
        ws.onopen = null;
        ws.onmessage = null;
        ws.onclose = null;
        ws.onerror = null;

        if (
          ws.readyState === WebSocket.OPEN ||
          ws.readyState === WebSocket.CONNECTING
        ) {
          ws.close();
        }

        ws = null;
      }
    };

    connectWebSocket();

    return cleanupWebSocket;
  }, [setSpxSnapshot]);

  return null;
}